import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegisterMain = _resolveComponent("RegisterMain")!

  return (_ctx.$userLoadStatus.value == 'loaded')
    ? (_openBlock(), _createBlock(_component_RegisterMain, {
        key: 0,
        class: "sf-container"
      }))
    : _createCommentVNode("", true)
}